import {Auth0Client} from "@auth0/auth0-spa-js";
import {AUTH0_CLIENT_ID, AUTH0_DOMAIN} from "../environment.ts";



export const AUTH0_CLIENT = new Auth0Client({
    domain: AUTH0_DOMAIN,
    clientId: AUTH0_CLIENT_ID,
});